import store from '../store'
import Vue, { del } from 'vue'

export default {
  data() {
    return {
      addingToCart: false,
      hotImage: 'themes/storefront/public/images/hot.svg',
      coinImage: 'themes/storefront/public/images/coin.svg',
      newBadgeImage: 'themes/storefront/public/images/new-badge.svg',
      productQty: 1,
      showPop: false,
      apiLoading: false,
      qty: undefined
    }
  },
  computed: {
    preOrder() {
      return this.product.qty_in_stock <=0 && this.product.is_pre_order
    },
    maxSellingQty() {
      return this.product.max_selling_qty
    },
    productUrl() {
      return route('products.show', this.product.slug)
    },
    hasNoOption() {
      return !this.hasAnyOption
    },
    hasBaseImage() {
      return this.product.base_image !== null && this.product.base_image !== ''
    },
    baseImage() {
      if (this.product.base_image) {
        return this.product.base_image
      } else {
        return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
      }
    },
    getBaseImage() {
      if (this.cartItem.qty == 1 || !this.product.qd_enabled)
        return this.baseImage;
      else {
        let level = this.product.quantity_discount_with_min_max.find((item) => {
          return this.cartItem.qty >= item.min_val && (this.cartItem.qty <= item.max_val || item.max_val == null)
        })
        if (level)
          if (level.media[0])
            return level.media[0].original_url
        return this.baseImage;
      }
    },
    inWishlist() {
      return store.inWishlist(this.product.id)
    },
    inCompareList() {
      return store.inCompareList(this.product.id)
    }
  },

  methods: {
    syncWishlist() {
      store.syncWishlist(this.product.id)
      this.$emit('syncWishlist', this.product)
    },
    syncCompareList() {
      store.syncCompareList(this.product.id)
    },
    addToCartData (data) {
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      dataLayer.push({
        event    : "add_to_cart",
        ecommerce: {
          items: [{
            item_name     : data['name'], // Name or ID is required.
            item_id       : data['id'],
            price         : data['price'],
            item_brand    : "",
            item_category : data['categories0'] || "",
            item_category2: data['categories1'] || "",
            item_category3: data['categories2'] || "",
            item_category4: data['categories3'] || "",
            item_variant  : "",
            item_list_name: "",  // If associated with a list selection.
            item_list_id  : "",  // If associated with a list selection.
            index         : 0,  // If associated with a list selection.
            quantity      : data['quantity'],
          }]
        }
      });
    },
    addToCart() {
      this.addingToCart = true
      this.addToCartData({
        name: this.product.name,
        id: this.product.id,
        price: this.product.price.amount,
        quantity: this.product.qty_in_stock,
        categories0: "", //todo change to actual category
        categories1: "",
        categories2: "",
        categories3: "",
      });
      $.ajax({
        method: 'POST',
        url: route('cart.items.store', {
          product_id: this.product.id,
          qty: this.productQty
        })
      })
        .then(cart => {
          store.updateCart(cart)
          this.$successNotify("Product has been added to your cart")
        })
        .catch(xhr => {
          this.$errorNotify(xhr.responseJSON.message)
        })
        .always(() => {
          this.addingToCart = false
        })
    },
    getSB(qty, cartItem = null, storeCart = false) {
        this.checkMaxQty(qty)
        if (storeCart == true)
          this.storeCart(cartItem, qty)
        return this.maxSellingQty
    },
    updateQuantity(qty) {
      this.qty = qty
      this.productQty = qty
      if (qty != '' && qty != 0) {
        this.getSB()
      }
    },
    debounce(callback, delay) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(callback, delay)
    },
    updateCartQuantity(cartItem, qty) {
      if (qty != '') {
        this.qty = qty
        this.productQty = qty
      }
      else {
        this.qty = 1
        this.productQty = 1
      }
      var that = this
      that.getSB(this.qty, cartItem, true)

    },
    storeCart(cartItem, qty) {
      if (qty < 1 || this.exceedsMaxStock(cartItem, qty)) {
        return
      }

      if (isNaN(qty)) {
        qty = 1
      }

      this.loadingOrderSummary = true

      qty = qty > this.maxSellingQty ? this.maxSellingQty : qty
      // cartItem.qty = qty

      $.ajax({
        method: 'PUT',
        url: route('cart.items.update', { cartItemId: cartItem.id }),
        data: { qty: qty || 1 }
      })
        .then(cart => {
          store.updateCart(cart)
        })
        .catch(xhr => {
          this.$errorNotify(xhr.responseJSON.message)
        })
        .always(() => {
          this.loadingOrderSummary = false
        })
    },
    checkMaxQty() {
      this.showPop = false
      if (this.qty < 1 || this.exceedsMaxStock(this.qty)) {
        this.productQty = this.maxSellingQty
        this.showPop = true
        setTimeout(() => {
          this.showPop = false
        }, 3000)
      } else {
        if (isNaN(this.qty)) {
          this.qty = 1
        }

        this.productQty = this.qty
      }
    },
    exceedsMaxStock(qty) {
      return this.maxSellingQty < qty
    }
  }
}
